<template>
  <OverlayPanel
    v-if="showPanel"
    ref="searchFilters"
    id="search-filters"
    style="width: 100%"
    appendTo="#search-options"
    :dismissable="false"
  >
    <slot :isPanel="showPanel"></slot>
  </OverlayPanel>
  <Sidebar
    v-else
    position="full"
    v-model:visible="visible"
    :dismissable="false"
  >
    <div style="padding: 40px 15px 0 15px">
      <slot :isPanel="showPanel"></slot>
    </div>
  </Sidebar>
</template>

<script>
import { useMediaQuery } from '@vueuse/core';
import Sidebar from 'primevue/sidebar';

export default {
  name: 'SearchContainer',
  components: {
    Sidebar,
  },
  setup() {
    const showPanel = useMediaQuery('(min-width: 1024px)');
    return { showPanel };
  },
  data() {
    return { visible: false };
  },
  methods: {
    toggle(event) {
      if (this.showPanel) {
        this.$refs.searchFilters.toggle(event);
        this.$nextTick(() => {
          const element = document.querySelector('#search-filters');
          if (element?.style?.top) {
            element.style.top = '31.5px';
          }
        });
      } else {
        this.visible = true;
      }
    },
    hide() {
      if (this.showPanel) {
        this.$refs.searchFilters.hide();
      } else {
        this.visible = false;
      }
    },
  },
};
</script>

<style>
</style>
